import { render, staticRenderFns } from "./AudioAttachmentPlayerView.vue?vue&type=template&id=145781a0&scoped=true&"
import script from "./AudioAttachmentPlayerView.vue?vue&type=script&lang=ts&"
export * from "./AudioAttachmentPlayerView.vue?vue&type=script&lang=ts&"
import style0 from "./AudioAttachmentPlayerView.vue?vue&type=style&index=0&id=145781a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145781a0",
  null
  
)

export default component.exports